/**
 * A bought service's supplier and cost as the order page enters them
 * (supplier interface spec 12): Add extra and *Change supplier…* on a
 * fulfilment or installation bought from a supplier.
 */
import type { OrderStepFailure } from "./order-to-invoice-presentation";

/** The catalogue's bound on a cost (its bodies' `cost_pence`). */
const MAX_COST_PENCE = 100_000_000;

/** "30", "30.5", "£1,030.50" → pence; null when it isn't a cost above £0 and within the bound. */
export function costPenceOf(pounds: string): number | null {
  const text = pounds.trim().replace(/^£/, "").replace(/,/g, "");
  if (!/^\d+(\.\d{1,2})?$/.test(text)) return null;
  const pence = Math.round(Number(text) * 100);
  return pence > 0 && pence <= MAX_COST_PENCE ? pence : null;
}

/** The server's refusal with the supplier's own error dropped: a supplier chosen again is not yet refused. */
export function withoutSupplierRefusal(
  failure: OrderStepFailure | null,
): OrderStepFailure | null {
  if (!failure?.fieldErrors.supplier_no) return failure;
  const { supplier_no: _refused, ...rest } = failure.fieldErrors;
  return { ...failure, fieldErrors: rest };
}
